import React, { useEffect, useState } from 'react';
import { Box, Chip, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import client from '../api/client';

export default function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    client.get('/orders').then(r => setOrders(r.data)).catch(console.error);
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" mb={3}>{t('orders.title')}</Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('orders.orderId')}</TableCell>
            <TableCell>{t('orders.date')}</TableCell>
            <TableCell>{t('orders.paidAt')}</TableCell>
            <TableCell>{t('orders.total')}</TableCell>
            <TableCell>{t('orders.currency')}</TableCell>
            <TableCell>{t('orders.status')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders.map(o => (
            <TableRow key={o.orderId}>
              <TableCell>{o.orderId}</TableCell>
              <TableCell>{new Date(o.createdAt).toLocaleDateString()}</TableCell>
              <TableCell>{o.paidAt ? new Date(o.paidAt).toLocaleDateString() : '—'}</TableCell>
              <TableCell>{o.totalPrice}</TableCell>
              <TableCell>{o.currency}</TableCell>
              <TableCell>
                <Chip label={o.status} color={o.status === 'CONFIRMED' || o.status === 'PAID' ? 'success' : o.status === 'OFFLINE' ? 'info' : 'default'} size="small" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}
